import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'ticketTime',
})
export class TicketTimePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(date: string | Date): string {
        if (date) {
            const dateObject = new Date(date);
            const isDateInvalid = isNaN(dateObject.getTime());

            if (isDateInvalid) {
                return '';
            }

            const year = dateObject.getFullYear();
            const month = dateObject.getMonth();
            const day = dateObject.getDate();

            const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
            if (yesterday.getFullYear() === year && yesterday.getMonth() === month && yesterday.getDate() === day) {
                return this.translateService.instant('yesterday');
            } else {
                const today = new Date();

                if (today.getFullYear() === year && today.getMonth() === month && today.getDate() === day) {
                    return formatDate(dateObject, 'HH:mm', 'en-US');
                }

                return formatDate(dateObject, 'dd.MM.yyyy', 'en-US');
            }
        } else {
            return '';
        }
    }
}
